import React from "react"
import styles from "./rich-text.module.scss"

const RichText = () => {
 return <div>RichText</div>
}

export default RichText